// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyBofvKD9SF788mhJ4p-uAUMbTBa_A7b6Dw",
  authDomain: "assignment-10-client-a316b.firebaseapp.com",
  projectId: "assignment-10-client-a316b",
  storageBucket: "assignment-10-client-a316b.appspot.com",
  messagingSenderId: "402033238943",
  appId: "1:402033238943:web:bc6283da50ee1ea01293aa"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export default app;